import { render, staticRenderFns } from "./Tindakan.vue?vue&type=template&id=468fac53&"
import script from "./Tindakan.vue?vue&type=script&lang=js&"
export * from "./Tindakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports